export const COMPANY_NAME_MAX_LENGTH = 140;
export const CITY_MAX_LENGTH = 40;
export const LEGAL_ADDRESS_MAX_LENGTH = 60;
export const ZIP_CODE_MAX_LENGTH_DEFAULT = 5;
export const ZIP_CODE_MAX_LENGTH_LATVIAN = 4;
export const MIN_PASSWORD_LENGTH = 8;
export const CARD_PREFIX_MAX_LENGTH = 11;
export const CARD_NUMBER_MAX_LENGTH = 8;